module.exports = __webpack_public_path__ + "img/multiformats.68f0f748.svg";